export class Meeting {
  bookingType: string;
}
